import { requestUpload } from '../../../../sharedLegacy/utils/api'
import {
  HTTPMethod,
  type APIResponse,
} from '../../../../sharedLegacy/utils/api.types'

const uploadEndpoint = () => ({
  slide: () => '/api/2/live/slide/upload',
  handout: () => '/api/2/live/attachment/upload',
  fileUpload: () => '/api/2/file/upload',
})

type UploadSlideRequest = {
  /** ID of the live object (webinar) */
  live_id: string
}

type UploadSlideDto = {
  /** Filename given by the server */
  filename: string
  /** Relative path to the uploaded file */
  url: string
}

type UploadHandoutRequest = {
  /** ID of the live object (webinar) */
  live_id: string
  /** Flag indicating if the handout should be shared */
  hidden_p: boolean
}

type UploadHandoutDto = {
  /** Filename of the handout */
  filename: string
  /** Name of the file icon */
  icon_name:
    | 'audio'
    | 'video'
    | 'presentation'
    | 'image'
    | 'document'
    | 'generic'
  /** Size of the file in bytes */
  size: number
  /** Relative path to the file */
  url: string
}

type UploadActionCardImageRequest = {
  /** ID of the action card */
  object_id: string
  /** Boolean indicating whether this should be rescaled as an image or not */
  image_p: boolean
}

type UploadActionCardImageDto = {
  /** Filename given by the server */
  filename: string
  /** Relative path to the uploaded file */
  url: string
}

export async function uploadSlide(
  liveId: string,
  file: File
): Promise<UploadSlideDto[]> {
  const { data } = await requestUpload<
    UploadSlideRequest,
    APIResponse<UploadSlideDto[]>
  >({
    method: HTTPMethod.POST,
    url: uploadEndpoint().slide(),
    files: [['file', file]],
    data: {
      live_id: liveId,
    },
  })
  return data
}

export async function uploadHandout(
  liveId: string,
  file: File
): Promise<UploadHandoutDto> {
  const { data } = await requestUpload<
    UploadHandoutRequest,
    APIResponse<UploadHandoutDto>
  >({
    method: HTTPMethod.POST,
    url: uploadEndpoint().handout(),
    files: [['file', file]],
    data: {
      live_id: liveId,
      hidden_p: true, // always have handouts hidden coming from the tray.
    },
  })
  return data
}

export async function uploadActionCardImage(
  liveId: string,
  file: File
): Promise<UploadActionCardImageDto> {
  const { data } = await requestUpload<
    UploadActionCardImageRequest,
    APIResponse<UploadActionCardImageDto>
  >({
    method: HTTPMethod.POST,
    url: uploadEndpoint().fileUpload(),
    files: [['file', file]],
    data: {
      object_id: liveId,
      image_p: true,
    },
  })
  return data
}
